module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_135deg.1c065d5f.png";